import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { debounceTime, map, tap } from 'rxjs/operators';
import * as STATES from 'src/assets/states.json';
import * as STOP_WORDS from 'src/assets/stop-words.json';
import { HttpService } from 'src/services/http.service';
import * as accents from 'remove-accents';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss']
})
export class FilterDialogComponent implements OnInit {

  states: Array<any> = [];
  form: FormGroup;
  filteredDesiredJobTitle$: Observable<any>;
  allVacancies: Array<any> = [];
  allBranch: Array<any> = [];
  allRoleLevel: Array<any> = [];
  allOffices: Array<any> = [];
  allSpecializationName: Array<any> = [];
  filteredCourses$: Observable<any>;
  filteredCities$: Observable<any>;
  filteredDistricts$: Observable<any>;
  filteredStates$: Observable<any>;
  filteredVacancies$: Observable<any>;
  filteredBranch$: Observable<any>;
  filteredRoleLevel$: Observable<any>;
  filteredOffices$: Observable<any>;
  filteredSpecializationName$: Observable<any>;
  allCourses: Array<any>;
  genders$: Observable<any>;
  cities: Array<any> = [];
  districts: Array<any> = [];
  totalCandidates: number = 0;
  submiting: boolean = false;
  showCity: boolean = false;
  showDistrict: boolean = false;
  stopWords: string[] = [];
  ages: any[] = [];

  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];

  constructor(
    fb: FormBuilder,
    private dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private http: HttpService,
    private change: ChangeDetectorRef
  ) {

    const start = 15;
    const end = 64;

    this.ages = Array.from({ length: end - start + 1 }, (_, index) => start + index);
    this.ages.push('65+');

    this.states = (STATES as any).default;
    this.form = fb.group(
      {
        educationLevel: [null],
        ageEnd: [null],
        ageStart: [null],
        gender: [null],
        city: fb.control(null, { updateOn: 'submit' }),
        state: fb.control(null, { updateOn: 'submit' }),
        district: [null],
        education: [null],
        institutionName: [null],
        courseName: [null],
        professional: [null],
        vacancy: [null],
        branch: [null],
        office: [null],
        roleLevel: [null],
        specializationName: [null],
        jobDescription: [[]],
        embracing: [false]
      }
    )
    this.stopWords = Object.values(STOP_WORDS);

    if (data.filter.stateInitials) {

      data.filter.state = {
        sigla: data.filter.stateInitials,
        nome: data.filter.stateName
      }
      this.form.patchValue({
        state: data.filter.state,
        city: data.filter.city
      })


      this.http.list('locality:city', { initials: data.filter.stateInitials })
        .subscribe(
          (cities: any) => {
            this.cities = cities;
          }
        );
    }

    if (data.filter.city) {

      this.http.list('locality:district', { city: data.filter.city })
        .subscribe(
          (districts: any) => {
            this.districts = districts;
          }
        );

    }

    this.form.valueChanges
      .subscribe((data) => {
        if (this.disableSearch() == false)
          this.getTotalInFilter();
      })

    if (data.filter.state)
      this.showCity = true;

    this.form.patchValue(data.filter)

  }

  ngOnInit(): void {

    this.http.getGlobalLoadingIndicator()
      .subscribe(
        result => {
          const { trigger } = result;

          this.submiting = trigger === 'pre';

          if (trigger === 'pre')
            this.form.disable({ emitEvent: false });
          else this.form.enable({ emitEvent: false });
          this.change.detectChanges();

        }
      )

    this.filteredCourses$ = this.form.get('courseName')
      .valueChanges
      .pipe(map(courseName => this._filterCourses(courseName)));

    // this.filteredCities$ = this.form.get('city')
    //   .valueChanges
    //   .pipe(map(city => this._filterCities(city)));

    this.filteredDistricts$ = this.form.get('district')
      .valueChanges
      .pipe(map(district => this._filterDistricts(district)));

    this.http.list('course')
      .subscribe((courses: any) => this.allCourses = courses)

    this.genders$ = this.http.get('gender');

    // this.filteredStates$ = this.form.get('state')
    //   .valueChanges
    //   .pipe(
    //     map(state => this._filterStates(state))
    //   );

    this.form.get('ageStart')
      .valueChanges
      .subscribe((ageStart) => {
        if (ageStart == '65+') {
          this.form.get('ageEnd').disable();
          this.form.get('ageEnd').setValue(null);
        } else this.form.get('ageEnd').enable()
      })

    this.form.get('embracing')
      .valueChanges
      .subscribe(
        () => this.getTotalInFilter()
      )

  }

  onStateChange(event: any) {

    const { target } = event;
    this.filteredStates$ = of(this._filterStates(target.value));

  }

  onCityChange(event: any) {

    const { target } = event;
    this.filteredCities$ = of(this._filterCities(target.value));

  }

  disableSearch() {

    const data = this.form.getRawValue();
    const filledData = Object.values(data).filter((value: any) => (value && !Array.isArray(value)) || (Array.isArray(value) && value?.length > 0))

    return filledData.length == 0;

  }

  private doEducationalFilter() {

    const {
      institutionName,
      courseName
    } = this.form.getRawValue();

    if (
      (institutionName && institutionName.trim().length)
      || (courseName && courseName.trim().length)
    )
      this.form.get('education').setValue(true);
    else this.form.get('education').setValue(false);

  }

  private doProfessionalFilter() {

    const {
      vacancy,
      branch,
      office,
      roleLevel,
      specializationName
    } = this.form.getRawValue();

    if (
      (vacancy && vacancy.trim().length)
      || (branch && branch.trim().length)
      || (office && office.trim().length)
      || (roleLevel && roleLevel.trim().length)
      || (specializationName && specializationName.trim().length)
    )
      this.form.get('professional').setValue(true);
    else this.form.get('professional').setValue(false);

  }

  getTotalInFilter() {

    // console.log('TOTAL', this.form.getRawValue())
    if (this.form.valid) {

      const data = this.form.getRawValue();

      data['stateInitials'] = '';
      data['stateName'] = '';

      if (data.state) {
        if (typeof data.state == 'object') {
          data['stateInitials'] = data.state.sigla;
          data['stateName'] = data.state.nome;
        } else {
          data['stateInitials'] = data.state;
          data['stateName'] = data.state;
        }
      }

      for (const key in data) {
        const value = data[key];
        if (typeof value === 'string')
          data[key] = value.trim();
      }

      const filledData = Object.values(data).filter((item: any) => (!Array.isArray(item) && item) || (Array.isArray(item) && item.length > 0));

      this.totalCandidates = 0;
      if (filledData.length)
        this.getTotalCandidates(data);
    }

  }

  public displayState(state: any): string {
    return state ? state.nome : '';
  }

  public onAgeRangeSelected() {

    this.form.patchValue({
      professional: false,
      vacancy: null,
      specializationName: null,
      branch: null,
      roleLevel: null
    }, { emitEvent: false });
    this.form.get('vacancy').markAsPristine({ onlySelf: true });

  }

  public onGenderSelected() {

    this.form.patchValue({
      professional: false,
      vacancy: null,
      specializationName: null,
      branch: null,
      roleLevel: null
    }, { emitEvent: false });
    this.form.get('vacancy').markAsPristine();

  }

  public onEducationLevelSelected() {

    this.form.patchValue({
      professional: false,
      vacancy: null,
      specializationName: null,
      branch: null,
      roleLevel: null
    }, { emitEvent: false });
    this.form.get('vacancy').markAsPristine();

  }

  public onStateSelected(event: MatAutocompleteSelectedEvent) {

    this.form.patchValue({
      state: event.option.value
    }, { emitEvent: false });

    this.form.get('vacancy').markAsPristine();
    this.form.get('city').markAsPristine();
    this.showCity = true;

  }

  public onCitySelected(event: MatAutocompleteSelectedEvent) {

    this.form.patchValue({
      city: event.option.value
    }, { emitEvent: true });

    this.form.get('vacancy').markAsPristine();

  }

  onDistrictSelected() {

    this.form.patchValue({
      professional: false,
      vacancy: null,
      specializationName: null,
      branch: null,
      roleLevel: null
    }, { emitEvent: false });
    this.form.get('vacancy').markAsPristine();

  }

  onOfficeSelected(args: MatAutocompleteSelectedEvent) {
    this.getTotalInFilter();
  }

  public onVancancySelected(args: MatAutocompleteSelectedEvent) {

    this.form.patchValue({
      specializationName: null,
      branch: null,
      roleLevel: null
    }, { emitEvent: false });
    this.form.get('specializationName').markAsPristine();

  }

  onSpecializationSelected(args: MatAutocompleteSelectedEvent) {

    this.form.patchValue({
      //branch: null,
      roleLevel: null
    }, { emitEvent: false });
    this.form.get('roleLevel').markAsPristine();

  }

  onBranchSelected(args: MatAutocompleteSelectedEvent) {

    this.form.get('specializationName').markAsPristine();
    this.form.patchValue({
      specializationName: null
    });
  }

  onRoleLevelSelected() {
    this.getTotalInFilter();
  }

  private getTotalCandidates(params) {

    this.http.get('candidates:total', { searchs: JSON.stringify(params) })
      .subscribe(
        (result: any) => {
          const { records } = result;
          this.totalCandidates = parseInt(records);
        }
      )

  }

  // private _filterVacancies(vacancy) {
  //   if (vacancy == null) return;
  //   vacancy = accents.remove(vacancy).toLowerCase().trim();
  //   return this.allVacancies.filter(_vacancy => accents.remove(_vacancy.professional_name).toLowerCase().includes(vacancy));
  // }

  // private _filterBranch(branch) {
  //   if (branch == null) return;
  //   branch = accents.remove(branch).toLowerCase().trim();
  //   return this.allBranch.filter(_branch => accents.remove(_branch.branch).toLowerCase().includes(branch));
  // }

  // private _filterOffices(office) {
  //   if (office == null) return;
  //   office = accents.remove(office).toLowerCase().trim();
  //   return this.allOffices.filter(_office => accents.remove(_office.office).toLowerCase().includes(office));
  // }

  private _filterCourses(course) {
    course = course.toLowerCase().trim();
    return this.allCourses.filter(_course => _course.course_name.toLowerCase().includes(course));
  }

  private _filterCities(city) {
    if (city == null) return;
    city = accents.remove(city).toLowerCase().trim();
    return this.cities.filter(_city => accents.remove(_city.name).toLowerCase().indexOf(city) > -1);
  }

  private _filterDistricts(district) {
    if (district == null) return;
    district = accents.remove(district).toLowerCase().trim();
    return this.districts.filter(_district => accents.remove(_district.district).toLowerCase().indexOf(district) > -1);
  }

  // private _filterSpecializationName(specializationName) {
  //   if (specializationName === null) return;
  //   specializationName = accents.remove(specializationName).toLowerCase().trim();
  //   return this.allSpecializationName.filter(_specialization_name => accents.remove(_specialization_name.specialization_name).toLowerCase().indexOf(specializationName) > -1);
  // }

  // private _filterRoleLevel(roleLevel) {

  //   if (roleLevel === null) return;
  //   roleLevel = accents.remove(roleLevel).toLowerCase().trim();
  //   return this.allRoleLevel.filter(_role_level => accents.remove(_role_level.role_level).toLowerCase().indexOf(roleLevel) > -1);

  // }

  private _filterStates(state) {

    if (typeof state !== 'string') return;

    let name = accents.remove(state.toLowerCase().trim());
    return this.states.filter(_state => accents.remove(_state.nome).toLowerCase().indexOf(name) > -1
      || _state.sigla.toLowerCase().indexOf(name) > -1);

  }

  submit() {

    const data = this.form.getRawValue()

    for (const key in data) {
      const value = data[key];
      if (typeof value === 'string') {
        data[key] = value.trim();
        if (data[key].trim() == 0)
          data[key] = null;

      }
    }

    this.dialogRef.close(data);

  }

  onFocusInput(inputName: string) {

    const pristine = this.form.get(inputName).pristine;

    if (pristine) {

      const elementInput = document.getElementById(inputName);
      const inputControl = this.form.get(inputName);
      inputControl.markAsDirty();

      switch (inputName) {
        case 'state': {
          inputControl.setValue(' ');
        } break;
        case 'city': {
          const data = this.form.getRawValue();

          this.http.list('locality:city', { initials: data.state.sigla })
            .subscribe(
              (cities: any) => {

                this.cities = cities;
                inputControl.setValue('');
                setTimeout(() => elementInput.focus(), 2000);
                // elementInput.focus()
              }
            );
        } break;
        case 'district':
          const data = this.form.getRawValue();
          this.http.list('locality:district', { city: data.city.trim() })
            .subscribe(
              (districts: any) => {
                this.districts = districts;
                elementInput.focus();
              }
            );
          break;
        case 'vacancy': {

          const data = this.form.getRawValue();

          this.http.list('vacancy', { filters: JSON.stringify(data) })
            .subscribe((vacancies: any) => {
              this.allVacancies = vacancies
              inputControl.setValue(' ');
              elementInput.focus();
            });

        } break;
        case 'specializationName': {

          const data = this.form.getRawValue();

          this.http.list('vacancy:specialization_name', { filters: JSON.stringify(data) })
            .subscribe((specializationName: any) => {
              this.allSpecializationName = specializationName;
              this.form.get(inputName).setValue(' ');
              elementInput.focus();
            });

        } break;
        case 'branch': {

          const data = this.form.getRawValue();
          this.http.list('vacancy:branch', { filters: JSON.stringify(data) })
            .subscribe((branch: any) => {
              this.allBranch = branch;
              inputControl.setValue(' ');
              elementInput.focus();
            });

        } break;
        case 'roleLevel': {
          const data = this.form.getRawValue();

          this.http.list('vacancy:role_level', { filters: JSON.stringify(data) })
            .subscribe((roleLevel: any) => {
              this.allRoleLevel = roleLevel
              inputControl.setValue(' ');
              elementInput.focus();
            });
        }; break;

      }

    }

  }

  clearFilter() {
    this.form.reset({ jobDescription: [] }, { emitEvent: false });
    this.totalCandidates = 0;
  }

  removeDesiredJob(index: number) {
    this.form.get('desiredJob').value.splice(index, 1);
  }


  removeWord(index: number) {
    const items = this.form.get('jobDescription').value as string[];
    items.splice(index, 1);
    this.form.get('jobDescription').setValue(items);
  }

  addDesiredJob(event: MatChipInputEvent): void {

    const input = event.input;
    const value = event.value;

    if ((value || '').trim().length > 0) {

      const words = this.form.get('desiredJob').value || [];

      if (!words.includes(value)) {
        words.push(value.trim());
      }

    }

    if (input) {
      input.value = '';
    }

  }

  addJobDescription(event: MatChipInputEvent): void {
    const input = event.input;
    const value = (event.value || '').trim();

    if (value.length > 0 && !this.stopWords.includes(value)) {

      const words = this.form.get('jobDescription').value || [];

      if (!words.includes(value)) {
        words.push(value.trim());
        this.form.get('jobDescription').setValue(words);
      }

    }

    if (input) {
      input.value = '';
    }

  }

}
